import { FleeterIcon } from "./fleeter-icon";

export const CopilotHeader = () => (
	<div className="flex flex-col items-center gap-2 text-center">
		<div
			aria-hidden
			className="flex h-8 w-8 items-center justify-center text-[#0080FE]"
		>
			<FleeterIcon size={20} />
		</div>
		<h1 className="font-semibold text-2xl text-[#0080FE] leading-8">
			Copiloto Fleeter
		</h1>
		<p className="text-md text-tertiary">O seu copiloto na gestão de frotas</p>
	</div>
);
